// @ts-nocheck
import styled from 'styled-components';

const SpaceWrestler = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 100%;
`;

const SpaceAvatar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 75%;

    & img.space-avatar-image {
        width: 95%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        border: ${props => props.withWinner ? props.isWinner ? '1.5px solid gold' : '1px solid white' : '1px solid white'};
    }
`;

const SpaceName = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 25%;

    & h6.name-wrestler {
        font-size: 6px;
        color: white;
        text-align: center;
        margin: 0;
        padding: 0;
        line-height: 1;
    }
`;


function RenderWrestlerWhenTwoInSpace({ wrestler, side, withWinner = false }) {
    return (
        <SpaceWrestler className={`space-wrestler ${side}`}>
            <SpaceAvatar 
             className='space-avatar'
             withWinner={withWinner}
             isWinner={wrestler.pivot.is_winner}
            >
                <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} className='space-avatar-image' 
                />
            </SpaceAvatar>
            <SpaceName className='space-name'>
                <h6 className='name-wrestler'>{wrestler.name}</h6>
            </SpaceName>
        </SpaceWrestler>
    )
}

export default RenderWrestlerWhenTwoInSpace;